import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPart = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.8236 3C14.4957 3 13.1681 3.50309 12.1597 4.51139C11.2453 5.4268 10.7389 6.60907 10.655 7.8108L12.3773 7.93225C12.4333 7.13031 12.765 6.34934 13.381 5.73264C14.7379 4.37583 16.9093 4.37583 18.2662 5.73264C19.6231 7.08945 19.6231 9.26253 18.2662 10.6193C16.9093 11.9762 14.7379 11.9762 13.381 10.6193L12.7704 10.0087L11.4158 11.3632L11.0683 10.7846L9.58724 11.6736L11.4192 14.7267L12.9003 13.8378L12.3318 12.8898L12.826 12.3956C14.8466 13.83 17.6792 13.6488 19.4875 11.8406C21.5042 9.824 21.5042 6.52799 19.4875 4.51139C18.4792 3.50309 17.1516 3 15.8236 3ZM8.62403 13.2272L7.14296 14.1161L8.9749 17.1692L10.4577 16.282L8.62403 13.2272ZM6.18313 15.6697L4.70205 16.5586L6.534 19.6134L8.01507 18.7245L6.18313 15.6697ZM4.05767 18.7194L3 19.7787L4.2213 21L4.97533 20.246L4.05767 18.7194Z",
		fill: "currentColor"
	})
});
export default SvgPart;
